import {
  apiUrl,
  getList,
  deleteRecord,
  getSingleRecord,
  saveRecord,
  apiOptions,
  handleError,
  handleResponse,
  postAction,
  getAuditData,
  exportData,
} from './apiUtils';
import type { ApiListParamsWithUnderscores, ApiExportParams } from '../types/api/listParams';
import type { ListApiResponse } from '../types/apiResponse';
import type { CompanyTypeItemModel } from '../types/api';

const baseUrl = apiUrl + '/companyTypes/';

export function getCompanyTypes(
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<CompanyTypeItemModel>> {
  return getList(`${baseUrl}search`, params);
}

export function getAllCompanyTypes(): Promise<CompanyTypeItemModel[]> {
  return fetch(`${baseUrl}?_page=0`, apiOptions())
    .then(handleResponse)
    .catch(handleError);
}

export function getCompanyTypeById(id: string): Promise<CompanyTypeItemModel> {
  return getSingleRecord(baseUrl, id);
}

export function saveCompanyType(companyType: Partial<CompanyTypeItemModel>): Promise<{ id: string }> {
  return saveRecord(baseUrl, companyType);
}

export function deleteCompanyType(id: string): Promise<{ id: string }> {
  return deleteRecord(baseUrl, id);
}

export function getAudit(id: string): Promise<unknown> {
  return getAuditData(baseUrl, id);
}

export function addAudit(id: string, comment: string): Promise<unknown> {
  return postAction(`${baseUrl}${id}/audit`, { comment });
}

export function exportCompanyTypesData(params: ApiExportParams): Promise<void> {
  return exportData(`${apiUrl}/export/companyTypes/search`, 'name', params);
}
